import { sendGAEvent } from "@next/third-parties/google";

type EventParams = Record<string, string | number | boolean | null | undefined>;

function canSend(): boolean {
  if (typeof window === "undefined") return false;
  // sendGAEvent itself warns if GA not initialized; we hard-guard to avoid noisy logs.
  return Array.isArray(
    (window as unknown as { dataLayer?: unknown }).dataLayer,
  );
}

export function trackEvent(eventName: string, params: EventParams = {}) {
  if (!canSend()) return;
  sendGAEvent("event", eventName, params);
}

function getUtmParams(): EventParams {
  if (typeof window === "undefined") return {};
  const searchParams = new URLSearchParams(window.location.search);
  const keys = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content",
  ];

  const utm: EventParams = {};
  for (const key of keys) {
    const value = searchParams.get(key);
    if (value) utm[key] = value;
  }
  return utm;
}

export function trackLeadSignup(location: string, extra: EventParams = {}) {
  trackEvent("sign_up", { method: location, ...getUtmParams(), ...extra });
}

export function trackLeadLogin(location: string, extra: EventParams = {}) {
  trackEvent("login", { method: location, ...getUtmParams(), ...extra });
}

export function trackLeadContactSubmit(
  location: string,
  extra: EventParams = {},
) {
  trackEvent("generate_lead", {
    method: location,
    ...getUtmParams(),
    ...extra,
  });
}

export function trackViewDemo(location: string) {
  trackEvent("select_content", { content_type: "demo", item_id: location });
}
